import { Card, Col, Row, Button } from 'react-bootstrap';
import CustomImage from './CustomImage';
import constants from '../lib/constants';
import { ChevronRight } from "lucide-react";

const CardCompany = ({ data }) => {
    const getLogoUrl = (logoData) => {
        if (!logoData || typeof logoData !== 'string' || logoData === '[]') {
            return null;
        }
        try {
            const parsed = JSON.parse(logoData);
            if (Array.isArray(parsed) && parsed.length > 0 && parsed[0].name) {
                return `${constants.LOGO_URL}/${parsed[0].name}`;
            }
        } catch (error) {
            console.error('Failed to parse company_logo_url:', error);
        }
        return null;
    };

    const logoUrl = getLogoUrl(data.company_logo_url);

    return (
        <Card className="border-0 shadow card-company">
            <div className="card-header-bg text-center">
                <div className="avatar avatar-xl p-2 mb-2">
                    <div className="logo-frame position-relative h-100 overflow-hidden rounded-circle">
                        <CustomImage
                            src={logoUrl}
                            alt={`${data.title} logo`}
                            width={112}
                            height={112}
                            fallback={data.title ? data.title.charAt(0) : ''}
                        />
                    </div>
                </div>
                <h6 className="h6">{data.title}</h6>
                <p className="company-location mb-0">{`${data.location_city || ''}, ${data.location_country_name || ''}`}</p>
            </div>
            <Card.Body>
                <Row className="details-grid">
                    <Col xs={6}>
                        <div className="label-heading">Founded</div>
                        <p className="text-sm fw-bold mb-0">{data.company_founded || '—'}</p>
                    </Col>
                    <Col xs={6}>
                        <div className="label-heading">Company Size</div>
                        <p className="text-sm fw-bold mb-0">
                            {data.company_size_label ? data.company_size_label.replace(' employees', '') : '—'}
                        </p>
                    </Col>
                    <Col xs={6}>
                        <div className="label-heading">Hourly Rate</div>
                        <p className="text-sm fw-bold mb-0">{data.company_hourly_rate_label || '—'}</p>
                    </Col>
                    <Col xs={6}>
                        <div className="label-heading">Minimal Project</div>
                        <p className="text-sm fw-bold mb-0">{data.company_project_minimal_size_label || '—'}</p>
                    </Col>
                </Row>
            </Card.Body>
            <Card.Footer>
                <Button
                    href={`/company/${data.vl_url}`}
                    variant="link"
                    className="ps-0 d-inline-flex align-items-center"
                >
                    VIEW PROFILE <ChevronRight className="ms-2" size={12} />
                </Button>
            </Card.Footer>
        </Card>
    );
};

export default CardCompany;
